module.exports = __webpack_public_path__ + "static/media/SplashScreen.745cb97c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SplashScreen.mp4
// module id = 39
// module chunks = 1